import React from "react";
import styled from "styled-components";

function ElementButton(props) {
  const { element, coords, disabled, onClick, caption, image, selected, className} = props;

  return (
    <CardContainer
      className={className}
      disabled={disabled}
      selected={selected}
      active={false}
      location={coords}
      onClick={onClick}     
    >
      {/* <Icon symbol={element.symbol}></Icon> */}
      <Icon>
        <img src={image} width={50} alt={element.alt} />
      </Icon>
      <div>{element.caption}</div>
    </CardContainer>
  );
}

const Icon = styled.div`
  background-image: url(media/img/mission_elements/${({ symbol }) => symbol}.svg);
  background-repeat: no-repeat;
  background-position: center;
  filter: invert(68%) sepia(10%) saturate(1205%) hue-rotate(160deg) brightness(90%) contrast(83%);
  width: 100%;
  height: 45%;
  margin: -10px 0px 5px;
`;

const CardContainer = styled.button`
  position: absolute;
  top: ${({ location }) => location.top}px;
  left: ${({ location }) => location.left}px;

  width: 130px;
  height: 130px;
  cursor: pointer;
  z-index: 1;
  background-color: #283044;
  text-align: center;
  border-radius: 50%;
  transition: all 0.2s ease-in-out;

  border: 2px solid #78a1bb;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  font-family: 'Rajdhani';
  font-size: 19px;
  font-weight: bold;
  color: #78A1BB;
  line-height: 19px;

  &.disabled{
    pointer-events: none;
    cursor: default;
  }

  

  ${({ disabled }) =>
    disabled &&
    `
    pointer-events: none;
    opacity: .35;
    // transform: scale(0.85);
    `
  }
  ${({ disabled }) =>
    !disabled && 
    `
    &:hover{
      background-color: #78A1BB;      
      border:solid 2px #fff;
      color: #283044;
      transform: scale(1.2);
      //font-size: 1.25rem;
      ${Icon}{
        filter: invert(16%) sepia(10%) saturate(2020%) hue-rotate(185deg) brightness(93%) contrast(89%);
      }      
    }
`}
${({ selected }) =>
  selected &&
    ` 
    pointer-events: none; 
      background-color: #E18B00;      
      border:solid 2px #fff;
      color: #283044;
      transform: scale(1.2);
      ${Icon}{
        filter: invert(16%) sepia(10%) saturate(2020%) hue-rotate(185deg) brightness(93%) contrast(89%);
      }      
    }
`}
`;

export default ElementButton;
